// extracted by mini-css-extract-plugin
export var alternate = "_1x-j";
export var black = "_1x-6";
export var blue = "_1x-f";
export var blueLight = "_1x-e";
export var brand = "_1x-8";
export var darkMode = "_1x-b";
export var error = "_1x-a";
export var gray = "_1x-5";
export var grayBlue = "_1x-d";
export var iconWrapper = "_1x-3";
export var inactive = "_1x-7";
export var indigo = "_1x-g";
export var orange = "_1x-i";
export var pink = "_1x-h";
export var primary = "_1x-0";
export var purple = "_1x-9";
export var success = "_1x-4";
export var warning = "_1x-c";
export var white = "_1x-1";
export var whiteSuccess = "_1x-2";